/**
 * How long the shop keeps a published backoffice document in its server-side cache,
 * keyed by Payload slug. This is the worst-case delay between hitting Publish and the
 * change being visible in the shop: the cache entry is only refetched once its TTL has
 * elapsed.
 *
 * Single source of truth on purpose — the shop feeds these numbers into
 * `unstable_cache({ revalidate })`, and the backoffice renders the same numbers next to
 * the publish button (`PublishDelayIndicator`), so an editor is never shown a delay the
 * cache does not actually use.
 *
 * Keys are Payload collection/global slugs; the backoffice pins them to real slugs via
 * `Partial<Record<CollectionSlug | GlobalSlug, number>>`. To cover another template:
 * add its slug here, use the value in that template's `revalidate`, and the indicator
 * shows up in the backoffice automatically.
 */
export const CONTENT_CACHE_TTL_SECONDS = {
  /** `getDetailviewPageData` — both the pbk→id map and the Detailview content cache. */
  detailview: 10,
  /** `getAppConfigData` — the Shop config sections every shell reads. */
  config: 60,
} as const;
